export default "__VITE_ASSET__BfR_yW5e__"